const doc = [({"en":({"js":({"admin":({"routes":({"webshop":({"photo_products":({"products":"Products"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;